import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'
import { Box, Typography, ListItem, List, Checkbox } from '@mui/material'
import { ReactComponent as CheckboxIconSvg } from './Resources/checkbox.svg'
import { ReactComponent as CheckedboxIconSvg } from './Resources/checkedbox.svg'
import { Spinner } from 'packages/eid-ui'

const StyledListItem = styled(ListItem)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    // height: props.itemContainerHeight && props.itemContainerHeight,
    height: 'auto !important',
    marginBottom: '0.5rem',
    marginTop: '0.5rem',
    borderLeft: '3px solid transparent',

    '&:hover': {
        backgroundColor: 'inherit',
    },
    '&:focus-within': {
        outline: '2px solid #0057A0',
        outlineOffset: '2px',
        borderRadius: '4px',
        backgroundColor: '#f8f9fa',
    },
    '& span': {
        paddingTop: '0',
        paddingBottom: '0',
    },
    '& p': {
        width: '100%',
        padding: '0 0.5rem',

        borderRadius: '0.5rem',
        '&:hover': {
            backgroundColor: '#f1f1f4',
        },
    },
    '& .search-highlight2': {
        color: '#950167',
        fontWeight: 600,
        textDecoration: 'underline',
    },
}))

const StyledList = styled(List)({
    width: '100%',
})

const ActiveListItem = styled(StyledListItem)({
    background: '#fafcff',
    borderLeft: '0.3rem solid #0057A0',
    color: '#000 !important',
    '& .MuiBox-root': {
        '& p': {
            background: '#fff !important',
            color: '#000 !important',
        },
    },
})

const StyledCheckbox = styled(Checkbox)({
    '&:hover': {
        backgroundColor: 'transparent !important',
    },
})

const highlight = (text, searchKey) => {
    searchKey = new RegExp('(' + searchKey + ')', 'gi')
    return text.split(searchKey).map((o, i) =>
        i % 2 === 1 ? (
            <span className="search-highlight2" key={i}>
                {o}
            </span>
        ) : (
            o
        ),
    )
}

export default function CheckboxList(props) {
    const {
        fontSize,
        fontColor,
        itemContainerHeight,
        handleToggle,
        checked,
        loading,
        dataList,
        highlightText,
        fallbackMessage,
        highlightSelected = false,
        renderItemSuffix,
    } = props

    const isChecked = (item) => {
        return !item ? false : Boolean(checked.find((c) => c.id === item.id))
    }
    return loading ? (
        <Box
            width="100%"
            height="100%"
            display="flex"
            justifyContent="center"
            padding="2rem"
            marginLeft="-1rem"
        >
            <Spinner />
        </Box>
    ) : (
        dataList && (
            <StyledList>
                {dataList.length === 0 && <>{fallbackMessage}</>}
                {dataList.map((item, index) => {
                    const labelId = `checkbox-list-label-${item.friendlyName}`

                    const ListItemComponent =
                        highlightSelected && isChecked(item)
                            ? ActiveListItem
                            : StyledListItem

                    return (
                        <ListItemComponent
                            key={index}
                            role={undefined}
                            button
                            onClick={() => !item.disabled && handleToggle(item)}
                           
                        >
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                width="100%"
                            >
                                <Box display="flex" alignItems="center">
                                    <Box>
                                        <StyledCheckbox
                                         sx={{ 
                                            // height: itemContainerHeight,
                                            opacity: item.disabled ? 0.5 : 1,
                                            cursor: item.disabled ? 'not-allowed' : 'pointer',
                                        }}
                                            edge="start"
                                            color="primary"
                                            disabled={item.disabled || false}
                                            icon={
                                                <Box
                                                    display="flex"
                                                    alignItems="center"
                                                >
                                                    <CheckboxIconSvg></CheckboxIconSvg>
                                                </Box>
                                            }
                                            checkedIcon={
                                                <Box
                                                    display="flex"
                                                    alignItems="center"
                                                >
                                                    <CheckedboxIconSvg></CheckedboxIconSvg>
                                                </Box>
                                            }
                                            checked={isChecked(item)}
                                            tabIndex={0}
                                            disableRipple
                                            disableFocusRipple
                                            onKeyDown={(e) => {
                                                if (
                                                    e.key === 'Enter' ||
                                                    e.key === ' '
                                                ) {
                                                    e.preventDefault()
                                                    handleToggle(item)
                                                }
                                            }}
                                            inputProps={{
                                                'aria-labelledby': labelId,
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: fontColor,
                                                fontSize: fontSize
                                                    ? fontSize
                                                    : '1.4rem',
                                                wordBreak: 'break-word',
                                                wordWrap: 'break-word',
                                                overflow: 'auto',
                                                opacity: item.disabled ? 0.5 : 1,
                                            cursor: item.disabled ? 'not-allowed' : 'pointer',
                                            }}
                                        >
                                            {highlightText &&
                                            highlightText.length
                                                ? highlight(
                                                      item.friendlyName,
                                                      highlightText,
                                                  )
                                                : item.friendlyName}
                                        </Typography>
                                    </Box>
                                </Box>
                                {renderItemSuffix && (
                                    <Box>{renderItemSuffix(item)}</Box>
                                )}
                            </Box>
                        </ListItemComponent>
                    )
                })}
            </StyledList>
        )
    )
}

CheckboxList.propTypes = {
    fontSize: PropTypes.string,
    fontColor: PropTypes.string,
    itemContainerHeight: PropTypes.any,
    handleToggle: PropTypes.func,
    checked: PropTypes.array,
    dataList: PropTypes.array,
    highlightText: PropTypes.any,
    fallbackMessage: PropTypes.any,
}

CheckboxList.defaultProps = {}
